/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Sortingchoosedirection2Inputs */

const en__field_sortingchoosedirection2 = /** @type {(inputs: _Field_Sortingchoosedirection2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order`)
};

const de__field_sortingchoosedirection2 = /** @type {(inputs: _Field_Sortingchoosedirection2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reihenfolge`)
};

/**
* | output |
* | --- |
* | "Order" |
*
* @param {_Field_Sortingchoosedirection2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_sortingchoosedirection2 = /** @type {((inputs?: _Field_Sortingchoosedirection2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Sortingchoosedirection2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_sortingchoosedirection2(inputs)
	return de__field_sortingchoosedirection2(inputs)
});
export { _field_sortingchoosedirection2 as "_field_sortingChooseDirection" }